// Import alpineJS
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// Register plugins
Alpine.plugin(collapse);

// Initialize Alpine
window.Alpine = Alpine;
Alpine.start();
